import { Component, h, useState } from "@lukekaalim/act"
import { html } from "@lukekaalim/act-web"

import classes from './index.module.css';
import { assetURLs } from "../../assets";
import { LabeledInput } from "./input";
import { AccountDescription } from "../../defs/account";
import { useLogger } from "@kosmod/kit";
import { useFrontendCore, useFrontendServices } from "@kosmod/core";
import { AuthState } from "../../hooks";

export type SignOutProps = {
  account: AccountDescription,
  onSignOut(): void,

  auth: AuthState,
}

export const SignOut: Component<SignOutProps> = ({ account, onSignOut }) => {
  const { site } = useFrontendServices();

  return h(html.form, { classList: [classes.authenticateForm, classes.signUp], onSubmit(event) {
    event.preventDefault();
    onSignOut();
  }, }, [

    h(html.img, { className: classes.heroLogo, src: assetURLs.kosmodTransparentLogo, onClick: () => site.navigate({ path: '/' }) }),

    h(html.p, { className: classes.instructions }, [
      h(html.div, {}, `You are already logged in as`),
      h(html.strong, {}, account.username)
    ]),

    h(html.p, {}, [
      `To create or login to another account, first log out of your current account`,
    ]),

    h(html.input, { type: 'submit', name: 'Logout' }),

  ]);
}